export function queryParamsToApiParams(
  params: Record<string, string>,
  statusFilter: "ACTIVE" | "COMPLETE"
) {
  return {
    page: params.page,
    page_size: params.page_size,
    status: statusFilter,
    ordering: params.ordering,
    type: params.type && params.type.split(","),
    requestor: params.requestor && params.requestor.split(","),
    customer_group_id:
      params.customer_group_id && params.customer_group_id.split(","),
  };
}
